import type { ReactNode } from "react";
import { useLearnerSeatCutover } from "@/hooks/useLearnerSeatCutover";

/** Renders the new learner-seat experience only when the server cutover is ON. */
export function CutoverGate({ children, fallback }: { children: ReactNode; fallback: ReactNode }) {
  const { enabled, loading } = useLearnerSeatCutover();
  if (loading) {
    return (
      <div className="flex min-h-[40vh] items-center justify-center" aria-busy="true">
        <span className="sr-only">Loading</span>
      </div>
    );
  }
  return <>{enabled ? children : fallback}</>;
}

export default CutoverGate;
